export default __webpack_public_path__ + "static/media/icon-hobbies.0ae67280.svg";